import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { CardDataController } from '@colonist/game-card-types';
import { ModeSettingEnum } from '@colonist/game-base-types';
import { AudioManager, AudioType } from '@colonist/audio';
import { UIGamePopupInformationView } from './UIGamePopupInformationView.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { ActionState, CardEnum, TurnState } from '@colonist/game-states';
import { robberSkinController } from '../UIGameRobberSkinController.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import IconPirateShip from '@static/images/icon_pirate_ship.svg';
import { cardEnumsToCardState, CARD_IMAGES, CARD_TIP_TITLE } from '@colonist/ui-game';
import { getNestedTranslation } from '@colonist/i18n';
import IconDiscardResourceCards from '@static/images/icon_discard_resource_cards.svg';
import IconDiscardProgressCards from '@static/images/icon_discard_progress_cards.svg';
export class UIGamePopupController {
    getNextActionBoxId() {
        const id = this.nextActionBoxId;
        this.nextActionBoxId += 1;
        return id;
    }
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.ConfirmUseDevelopmentCard:
                this.showBaseActionBox(data);
                break;
            case UIGameEventEnums.SelectDiceNumbersConfirmation:
                this.showInventorBaseActionBox(data);
                break;
            case UIGameEventEnums.SelectCardsFromBankUsingDevelopmentCard:
                this.showCardSelectorWindowForDevelopmentCard(data);
                break;
            case UIGameEventEnums.SelectCardsForPendingDistribution:
                this.showCardSelectorWindowForPendingDistributions(data);
                break;
            case UIGameEventEnums.SelectCardToGiveToAnotherPlayer:
                this.showCardSelectorWindowForGivingCardToAnotherPlayer(data);
                break;
            case UIGameEventEnums.SelectCardsToDiscard:
                this.showCardDiscardPopup(data);
                break;
            case UIGameEventEnums.SelectPlayer:
                this.showSelectPlayer(data);
                break;
            case UIGameEventEnums.StealDevelopmentCardFromPlayer:
                this.showCardSelectorWindowToStealDevelopmentCard(data);
                break;
            case UIGameEventEnums.StealResourceCardFromPlayer:
                this.showCardSelectorWindowToStealResourceCard(data);
                break;
            case UIGameEventEnums.SelectPlayerForDevelopmentCard:
                this.showSelectPlayerUsingDevelopmentCard(data);
                break;
            case UIGameEventEnums.SelectPlayerAndCard:
                this.showSelectPlayerAndResourceCard(data);
                break;
            case UIGameEventEnums.SelectDice:
                this.showSelectDice(data);
                break;
            case UIGameEventEnums.GameStateUpdated:
                this.onGameStateUpdated();
                break;
            case UIGameEventEnums.ClosePopupUI:
                this.closeUI();
                break;
            case UIGameEventEnums.ShowTradeUI:
                this.closeUIOnShowTrade();
                break;
            case UIGameEventEnums.BeginnerModeStart:
                this.shouldShowBeginnerPopups = true;
                break;
            default:
                break;
        }
    }
    showCardSelectorWindowForDevelopmentCard(developmentCardSelectFormat) {
        this.playSoundForCardSelectorWindow();
        const cardData = CardDataController.getCardDataForCard(developmentCardSelectFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        this.showPickCardActionBox(popupInformation, developmentCardSelectFormat.selectCardFormat, {
            isSelectFromHand: false,
            colorTitleOnSelect: false,
            hideBadgeOfSelectedCards: developmentCardSelectFormat.selectCardFormat.amountOfCardsToSelect == 1 ? true : false,
            hideBadgeOfCardsToSelect: true,
            removeCardFromSelectionOnClick: false,
            showSelectedCardFooterInformation: false
        });
    }
    showCardSelectorWindowForPendingDistributions(pendingDistributionSelectFormat) {
        const popupInformation = UIGamePopupInformationView.getPopupInformationForPendingDistributions(pendingDistributionSelectFormat);
        if (popupInformation == undefined) return;
        this.showPickCardActionBox(popupInformation, pendingDistributionSelectFormat.selectCardFormat, {
            isSelectFromHand: false,
            colorTitleOnSelect: false,
            hideBadgeOfSelectedCards: true,
            hideBadgeOfCardsToSelect: true,
            removeCardFromSelectionOnClick: false,
            showSelectedCardFooterInformation: false,
            showRolledDice: true
        });
    }
    showCardSelectorWindowForGivingCardToAnotherPlayer(selectCardFormat) {
        const cardData = CardDataController.getCardDataForCard(selectCardFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        popupInformation.body = selectCardFormat.body;
        const playerValidator = this.uiGameManager.gameController.getPlayerState(selectCardFormat.playerReceivingCard);
        this.showPickCardActionBox(popupInformation, selectCardFormat.selectCardFormat, {
            isSelectFromHand: true,
            colorTitleOnSelect: false,
            hideBadgeOfSelectedCards: false,
            hideBadgeOfCardsToSelect: false,
            removeCardFromSelectionOnClick: false,
            showSelectedCardFooterInformation: false,
            playerValidator: playerValidator
        });
    }
    static getImageForCardDiscardPopup(selectCardFormat) {
        switch(selectCardFormat.selectCardFormat.allowableActionState){
            case ActionState.SelectCardsToDiscard:
                return IconDiscardResourceCards;
            case ActionState.SelectProgressCardsToDiscard:
                return IconDiscardProgressCards;
            default:
                throw new Error('Unsupported select card format');
        }
    }
    showCardDiscardPopup(discardCardFormat) {
        const popupInformation = {
            imagePath: UIGamePopupController.getImageForCardDiscardPopup(discardCardFormat),
            title: discardCardFormat.title,
            body: discardCardFormat.body
        };
        this.showPickCardActionBox(popupInformation, discardCardFormat.selectCardFormat, {
            isSelectFromHand: true,
            colorTitleOnSelect: true,
            hideBadgeOfSelectedCards: !discardCardFormat.selectCardFormat.showCardBadge,
            hideBadgeOfCardsToSelect: !discardCardFormat.selectCardFormat.showCardBadge,
            removeCardFromSelectionOnClick: false,
            showSelectedCardFooterInformation: false
        }, true);
    }
    showSelectPlayer(selectionFormat) {
        const popupInformation = {
            imagePath: selectionFormat.isPirate ? IconPirateShip : robberSkinController.getRobberSkin(),
            title: {
                key: selectionFormat.isPirate ? 'strings:game.tips.pirate.title' : 'strings:game.tips.robber.title'
            },
            body: {
                key: 'strings:game.prompts.selectWhoToRobFrom'
            }
        };
        const { isPirate, ...selectPlayerFormat } = selectionFormat;
        this.showPickPlayerActionBox(popupInformation, selectPlayerFormat, {
            showVictoryPoints: true
        });
    }
    showCardSelectorWindowToStealDevelopmentCard(stealDevelopmentCardFormat) {
        const cardData = CardDataController.getCardDataForCard(stealDevelopmentCardFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        const playerValidator = this.uiGameManager.gameController.getPlayerState(stealDevelopmentCardFormat.victim);
        this.showPickCardActionBox(popupInformation, stealDevelopmentCardFormat.selectCardFormat, {
            playerValidator: playerValidator,
            isSelectFromHand: false,
            colorTitleOnSelect: false,
            hideBadgeOfSelectedCards: true,
            hideBadgeOfCardsToSelect: true,
            removeCardFromSelectionOnClick: false,
            showSelectedCardFooterInformation: true
        });
    }
    showCardSelectorWindowToStealResourceCard(stealResourceCardFromAnotherPlayer) {
        const cardData = CardDataController.getCardDataForCard(stealResourceCardFromAnotherPlayer.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        this.showPickCardActionBox(popupInformation, stealResourceCardFromAnotherPlayer.selectCardFormat, {
            isSelectFromHand: false,
            colorTitleOnSelect: false,
            hideBadgeOfSelectedCards: false,
            hideBadgeOfCardsToSelect: false,
            removeCardFromSelectionOnClick: true,
            showSelectedCardFooterInformation: false,
            playerValidator: this.uiGameManager.gameController.getPlayerState(stealResourceCardFromAnotherPlayer.victim)
        });
    }
    showSelectPlayerUsingDevelopmentCard(developmentPlayerSelectFormat) {
        const cardData = CardDataController.getCardDataForCard(developmentPlayerSelectFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        if (developmentPlayerSelectFormat.overrideText != undefined) popupInformation.body = developmentPlayerSelectFormat.overrideText;
        const isKnightRobbery = developmentPlayerSelectFormat.developmentCardUsed == CardEnum.Knight;
        this.showPickPlayerActionBox(popupInformation, developmentPlayerSelectFormat.selectPlayerFormat, {
            developmentPlayerSelectFormat: developmentPlayerSelectFormat,
            showVictoryPoints: isKnightRobbery
        });
    }
    showSelectPlayerAndResourceCard(selectionFormat) {
        const cardData = CardDataController.getCardDataForCard(selectionFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        const showPickCardActionBoxOnPlayerSelect = (player)=>{
            this.showPickCardActionBox(popupInformation, {
                ...selectionFormat.selectCardFormat,
                cancelButtonActive: true
            }, {
                playerValidator: this.uiGameManager.gameController.getPlayerState(player),
                isSelectFromHand: true
            }, false, ()=>{
                this.showPickPlayerActionBox(popupInformation, {
                    ...selectionFormat.selectPlayerFormat,
                    cancelButtonActive: true
                }, {
                    onConfirmOverride: showPickCardActionBoxOnPlayerSelect,
                    onCancelOverride: ()=>this.showCommercialHarborCancelWarning(selectionFormat)
                });
            });
        };
        this.showPickPlayerActionBox(popupInformation, {
            ...selectionFormat.selectPlayerFormat,
            cancelButtonActive: true
        }, {
            onConfirmOverride: showPickCardActionBoxOnPlayerSelect,
            onCancelOverride: ()=>this.showCommercialHarborCancelWarning(selectionFormat)
        });
    }
    showSelectDice(selectDiceFormat) {
        const cardData = CardDataController.getCardDataForCard(selectDiceFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForCardData(cardData);
        this.showPickDiceActionBox(selectDiceFormat.cancelButtonActive, popupInformation, selectDiceFormat.allowableActionState);
    }
    playSoundForCardSelectorWindow() {
        switch(this.uiGameManager.gameController.currentState.actionState){
            case ActionState.SelectCardsForPendingDistributions:
                AudioManager.play(AudioType.YourTurn);
                break;
            default:
                break;
        }
    }
    isWrongState() {
        const currentActionBoxData = this.uiGameManager.gameStore.getState().actionBox.actionBoxData;
        if (!currentActionBoxData) return false;
        if (currentActionBoxData.type === 'base' && currentActionBoxData.props.isInfoOnly) return false;
        const didTurnStateChange = this.uiGameManager.gameController.currentState.turnState != this.turnStateOnPopupInitialization;
        if (didTurnStateChange) return true;
        const didActionStateChange = this.uiGameManager.gameController.currentStateValidator.getPlayerActionState(this.uiGameManager.gameController.myColor) != this.allowableActionState;
        if (didActionStateChange) return true;
        return false;
    }
    closeUI() {
        const hasActivePopup = this.uiGameManager.gameStore.getState().actionBox.actionBoxData != undefined;
        if (!hasActivePopup) return;
        this.uiGameManager.gameStore.getState().actionBox.hideActionBox();
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.PopupActive);
    }
    closeUIOnShowTrade() {
        const hasActivePopup = this.uiGameManager.gameStore.getState().actionBox.actionBoxData != undefined;
        if (!hasActivePopup) return;
        this.uiGameManager.socketGameSend.cancelAction();
        this.closeUI();
    }
    onGameStateUpdated() {
        if (this.isWrongState()) this.closeUI();
        if (!this.uiGameManager.gameController.isMyTurn) return;
        if (!this.shouldShowBeginnerPopups) return;
        if (this.shouldShowRobberInfoPopup()) this.onPlayerRolledSeven();
        if (this.shouldShowInitialPlacementPopup()) this.onInitialPlacements();
        this.previousTurnState = this.uiGameManager.gameController.currentState.turnState;
    }
    getShouldShowBeginnerPopups() {
        var _ClientUserState_userState;
        if (this.uiGameManager.gameController.isPlayerSpectator) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.hasZeroCompletedGames()) return true;
        return false;
    }
    shouldShowRobberInfoPopup() {
        const isValidActionState = ActionState.PlaceRobberOrPirate == this.uiGameManager.gameController.currentState.actionState;
        const isPreviousTurnStateDice = this.previousTurnState == TurnState.Dice;
        this.previousTurnState = this.uiGameManager.gameController.currentState.turnState;
        if (!isPreviousTurnStateDice) return false;
        if (!this.uiGameManager.gameController.diceState.diceThrown) return false;
        if (!isValidActionState) return false;
        if (this.uiGameManager.gameController.diceState.dice1 + this.uiGameManager.gameController.diceState.dice2 != 7) return false;
        return true;
    }
    onPlayerRolledSeven() {
        if (this.uiGameManager.gameController.isReplay) return;
        const popupInformation = UIGamePopupInformationView.getPopupInformationForPlayerRolledSeven(this.uiGameManager);
        this.showBaseActionBox(popupInformation);
    }
    shouldShowInitialPlacementPopup() {
        const validGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P
        ];
        if (!validGameModes.includes(this.uiGameManager.gameController.gameSettings.modeSetting)) return false;
        if (this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return false;
        return true;
    }
    onInitialPlacements() {
        if (this.uiGameManager.gameController.isReplay) return;
        const currentActionState = this.uiGameManager.gameController.currentState.actionState;
        const validActionStates = [
            ActionState.InitialPlacementRoadPlacement,
            ActionState.InitialPlacementPlaceSettlement
        ];
        if (!validActionStates.includes(currentActionState)) return;
        const popupInformation = currentActionState == ActionState.InitialPlacementRoadPlacement ? UIGamePopupInformationView.getPopupInformationForInitialRoadPlacement(this.uiGameManager) : UIGamePopupInformationView.getPopupInformationForInitialSettlementPlacement(this.uiGameManager);
        this.showBaseActionBox(popupInformation);
    }
    setPopupState(allowableActionState) {
        this.allowableActionState = allowableActionState;
        this.turnStateOnPopupInitialization = this.uiGameManager.gameController.currentState.turnState;
    }
    showInventorBaseActionBox(inventorPopupData) {
        this.showBaseActionBox(inventorPopupData.popupInformation, inventorPopupData.onCheckAction, inventorPopupData.onCancelAction);
    }
    showBaseActionBox(popupInformation, onConfirmOverride, onCloseOverride) {
        const isCardPopupInformation = 'cardEnum' in popupInformation;
        const cardsWithoutCancelButton = [
            CardEnum.VictoryPoint,
            CardEnum.ProgressCardPoliticsConstitution,
            CardEnum.ProgressCardSciencePrinter
        ];
        const showCancelButton = isCardPopupInformation ? cardsWithoutCancelButton.includes(popupInformation.cardEnum) == false : false;
        var _popupInformation_allowableActionState;
        const allowableActionState = isCardPopupInformation ? (_popupInformation_allowableActionState = popupInformation.allowableActionState) !== null && _popupInformation_allowableActionState !== void 0 ? _popupInformation_allowableActionState : ActionState.None : ActionState.None;
        this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
            id: this.getNextActionBoxId(),
            type: 'base',
            props: {
                title: isCardPopupInformation ? CARD_TIP_TITLE[popupInformation.cardEnum] : popupInformation.title,
                body: isCardPopupInformation ? popupInformation.cardBody : popupInformation.body,
                imagePath: isCardPopupInformation ? CARD_IMAGES[popupInformation.cardEnum] : popupInformation.imagePath,
                onConfirm: ()=>{
                    if (onConfirmOverride != undefined) {
                        onConfirmOverride();
                        return;
                    }
                    if (isCardPopupInformation) this.uiGameManager.socketGameSend.clickedDevelopmentCard(popupInformation.cardEnum);
                    this.closeUI();
                },
                ...showCancelButton && {
                    onClose: ()=>{
                        if (onCloseOverride != undefined) {
                            onCloseOverride();
                            return;
                        }
                        this.uiGameManager.socketGameSend.cancelAction();
                        this.closeUI();
                    }
                }
            }
        });
        this.uiGameManager.eventController.sendEvent(true, UIGameEventEnums.PopupActive);
        this.setPopupState(allowableActionState);
        return true;
    }
    updatePickCardActionBoxPlayerCardState() {
        const currentActionBoxData = this.uiGameManager.gameStore.getState().actionBox.actionBoxData;
        if (!currentActionBoxData) return;
        const isShowingBaseActionBox = currentActionBoxData.type === 'pickCard';
        if (isShowingBaseActionBox) {
            this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
                ...currentActionBoxData,
                props: {
                    ...currentActionBoxData.props,
                    playerCardState: cardEnumsToCardState(this.uiGameManager.gameController.getAllCardsInHand(this.uiGameManager.gameController.myColor))
                }
            });
        }
    }
    updatePickPlayerActionBoxPlayerCardState() {
        const actionBox = this.uiGameManager.gameStore.getState().actionBox;
        const actionBoxData = actionBox.actionBoxData;
        if (!actionBoxData) return;
        if (actionBoxData.type !== 'pickPlayer') return;
        const currentProps = actionBoxData.props;
        const oldValidators = currentProps.playerValidators;
        const newValidators = oldValidators.map((validator)=>this.uiGameManager.gameController.getPlayerState(validator.color));
        actionBox.setActionBoxData({
            ...actionBoxData,
            props: {
                ...currentProps,
                playerValidators: newValidators
            }
        });
    }
    showPickCardActionBox(popupInformation, selectCardFormat, { isSelectFromHand, colorTitleOnSelect, hideBadgeOfSelectedCards, hideBadgeOfCardsToSelect, removeCardFromSelectionOnClick, showSelectedCardFooterInformation, playerValidator, showRolledDice }, showDiscardCardFraction = false, onCancelOverride) {
        let selectedCards = [];
        const bankStockByCard = this.getBankStockForCardSelection(selectCardFormat);
        this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
            id: this.getNextActionBoxId(),
            type: 'pickCard',
            props: {
                title: popupInformation.title,
                body: popupInformation.body,
                imagePath: popupInformation.imagePath,
                amountOfCardsToSelect: selectCardFormat.amountOfCardsToSelect,
                initialCardsToSelect: selectCardFormat.validCardsToSelect,
                playerCardState: cardEnumsToCardState(this.uiGameManager.gameController.getAllCardsInHand(this.uiGameManager.gameController.myColor)),
                isSelectFromHand: isSelectFromHand !== null && isSelectFromHand !== void 0 ? isSelectFromHand : false,
                colorTitleOnSelect: colorTitleOnSelect !== null && colorTitleOnSelect !== void 0 ? colorTitleOnSelect : false,
                hideBadgeOfSelectedCards: hideBadgeOfSelectedCards !== null && hideBadgeOfSelectedCards !== void 0 ? hideBadgeOfSelectedCards : false,
                hideBadgeOfCardsToSelect: hideBadgeOfCardsToSelect !== null && hideBadgeOfCardsToSelect !== void 0 ? hideBadgeOfCardsToSelect : false,
                removeCardFromSelectionOnClick: removeCardFromSelectionOnClick !== null && removeCardFromSelectionOnClick !== void 0 ? removeCardFromSelectionOnClick : false,
                showSelectedCardFooterInformation: showSelectedCardFooterInformation !== null && showSelectedCardFooterInformation !== void 0 ? showSelectedCardFooterInformation : false,
                showRolledDice: showRolledDice !== null && showRolledDice !== void 0 ? showRolledDice : false,
                ...bankStockByCard != undefined && {
                    bankStockByCard: bankStockByCard
                },
                ...playerValidator != undefined && {
                    playerValidator: playerValidator
                },
                onCardSelect: (newSelectedCards)=>{
                    selectedCards = newSelectedCards;
                    this.uiGameManager.socketGameSend.selectCardsState(newSelectedCards);
                },
                onConfirm: ()=>{
                    if (selectedCards.length !== selectCardFormat.amountOfCardsToSelect) return;
                    this.uiGameManager.socketGameSend.selectCards(selectedCards);
                    this.closeUI();
                },
                ...selectCardFormat.cancelButtonActive && {
                    onClose: ()=>{
                        if (onCancelOverride) {
                            onCancelOverride();
                            return;
                        }
                        this.uiGameManager.socketGameSend.cancelAction();
                        this.closeUI();
                    }
                },
                ...showDiscardCardFraction && {
                    createTextOnSelect: (title, selectedCount, totalRequired)=>{
                        const isSaboteurDiscard = popupInformation.body.key === 'strings:game.prompts.saboteurDiscardCards';
                        const bodyOptions = isSaboteurDiscard ? {
                            ...popupInformation.body.options,
                            count: totalRequired
                        } : {
                            ...popupInformation.body.options,
                            amountToDiscard: totalRequired
                        };
                        return this.createCardFractionText(title, selectedCount, totalRequired, popupInformation.body.key, bodyOptions);
                    }
                }
            }
        });
        this.uiGameManager.eventController.sendEvent(true, UIGameEventEnums.PopupActive);
        this.setPopupState(selectCardFormat.allowableActionState);
    }
    getBankStockForCardSelection(selectCardFormat) {
        if (!selectCardFormat.disableCardTypesIfBankStackIsEmpty) return undefined;
        const bankStockByCard = {};
        for (const card of selectCardFormat.validCardsToSelect){
            bankStockByCard[card] = this.uiGameManager.gameController.bankState.resourceCards.getCardCountForCard(card);
        }
        return bankStockByCard;
    }
    showPickPlayerActionBox(popupInformation, selectPlayerFormat, options) {
        const developmentPlayerSelectFormat = options === null || options === void 0 ? void 0 : options.developmentPlayerSelectFormat;
        const onConfirmOverride = options === null || options === void 0 ? void 0 : options.onConfirmOverride;
        const onCancelOverride = options === null || options === void 0 ? void 0 : options.onCancelOverride;
        let selectedPlayer;
        let isPlayerSelectable;
        let invalidPlayerTooltip;
        let noValidTargetsBody;
        const requiresResourceCards = [
            ActionState.SelectWhoToRob,
            ActionState.MasterMerchantSelectPlayer
        ];
        if (requiresResourceCards.includes(selectPlayerFormat.allowableActionState)) {
            isPlayerSelectable = (playerValidator)=>playerValidator.resourceCards.getNumberOfCardsInInventory() > 0;
            invalidPlayerTooltip = {
                key: 'strings:game.gameState.gameLogs.pickPlayerCantStealNoCards',
                options: {
                    count: 1
                }
            };
            noValidTargetsBody = {
                key: 'strings:game.gameState.gameLogs.noPlayerToStealFrom'
            };
        }
        var _options_showVictoryPoints;
        this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
            id: this.getNextActionBoxId(),
            type: 'pickPlayer',
            props: {
                title: popupInformation.title,
                body: popupInformation.body,
                imagePath: popupInformation.imagePath,
                playerValidators: selectPlayerFormat.playersToSelect.map((playerColor)=>this.uiGameManager.gameController.getPlayerState(playerColor)),
                isPlayerSelectable: isPlayerSelectable,
                invalidPlayerTooltip: invalidPlayerTooltip,
                noValidTargetsBody: noValidTargetsBody,
                showVictoryPoints: (_options_showVictoryPoints = options === null || options === void 0 ? void 0 : options.showVictoryPoints) !== null && _options_showVictoryPoints !== void 0 ? _options_showVictoryPoints : false,
                onPlayerSelect: (player)=>{
                    selectedPlayer = player;
                },
                onConfirm: ()=>{
                    if (selectedPlayer == undefined) return;
                    const shouldContinueDevelopmentCard = this.uiGameManager.gameController.currentState.actionState == ActionState.None && (developmentPlayerSelectFormat === null || developmentPlayerSelectFormat === void 0 ? void 0 : developmentPlayerSelectFormat.developmentCardUsed) != undefined;
                    if (shouldContinueDevelopmentCard) this.uiGameManager.socketGameSend.clickedDevelopmentCard(developmentPlayerSelectFormat.developmentCardUsed);
                    this.uiGameManager.socketGameSend.selectPlayer(selectedPlayer);
                    this.closeUI();
                    if (onConfirmOverride != undefined) onConfirmOverride(selectedPlayer);
                },
                ...selectPlayerFormat.cancelButtonActive && {
                    onClose: ()=>{
                        if (onCancelOverride) {
                            onCancelOverride();
                        } else {
                            this.uiGameManager.socketGameSend.cancelAction();
                            this.closeUI();
                        }
                    }
                }
            }
        });
        this.uiGameManager.eventController.sendEvent(true, UIGameEventEnums.PopupActive);
        this.setPopupState(selectPlayerFormat.allowableActionState);
    }
    showPickDiceActionBox(cancelButtonActive, popupInformation, allowableActionState) {
        let selectedDicePair;
        this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
            id: this.getNextActionBoxId(),
            type: 'pickDice',
            props: {
                title: popupInformation.title,
                body: popupInformation.body,
                imagePath: popupInformation.imagePath,
                onConfirm: ()=>{
                    if (selectedDicePair == undefined) return;
                    this.uiGameManager.socketGameSend.confirmDiceSelection(selectedDicePair);
                    this.closeUI();
                },
                ...cancelButtonActive && {
                    onClose: ()=>{
                        this.uiGameManager.socketGameSend.cancelAction();
                        this.closeUI();
                    }
                },
                onDiceSelected: (dicePair)=>{
                    selectedDicePair = dicePair;
                }
            }
        });
        this.uiGameManager.eventController.sendEvent(true, UIGameEventEnums.PopupActive);
        this.setPopupState(allowableActionState);
    }
    showCommercialHarborCancelWarning(selectionFormat) {
        const cardData = CardDataController.getCardDataForCard(selectionFormat.developmentCardUsed);
        if (cardData == undefined) return;
        const cancelPopupInformation = {
            cardEnum: selectionFormat.developmentCardUsed,
            cardBody: {
                key: 'strings:game.prompts.endCommercialHarbor'
            },
            allowableActionState: selectionFormat.selectCardFormat.allowableActionState
        };
        this.showBaseActionBox(cancelPopupInformation, ()=>{
            this.uiGameManager.socketGameSend.cancelAction();
            this.closeUI();
        }, ()=>{
            this.showSelectPlayerAndResourceCard(selectionFormat);
        });
    }
    constructor(uiGameManager){
        this.nextActionBoxId = 1;
        this.createCardFractionText = (title, selectedCount, totalRequired, bodyKey, bodyOptions)=>{
            const discardCardsFraction = {
                key: 'strings:game.prompts.discardCardDenominator',
                options: {
                    selectedCardsAmount: selectedCount,
                    amountToDiscard: totalRequired
                }
            };
            const discardCardsTitleAndFraction = getNestedTranslation({
                key: 'strings:colonistCommon.utils.#append'
            }, {
                value1: title,
                value2: discardCardsFraction
            });
            const discardCardBody = {
                key: bodyKey,
                options: bodyOptions
            };
            return {
                title: discardCardsTitleAndFraction,
                body: discardCardBody
            };
        };
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.turnStateOnPopupInitialization = TurnState.InitialPlacement;
        this.previousTurnState = TurnState.InitialPlacement;
        this.shouldShowBeginnerPopups = this.getShouldShowBeginnerPopups();
        this.uiGameManager.gameStore.subscribe((state, prevState)=>{
            const hasPlayerCardStateChanged = state.gameState.playerStates !== prevState.gameState.playerStates;
            if (!hasPlayerCardStateChanged) return;
            this.updatePickCardActionBoxPlayerCardState();
            this.updatePickPlayerActionBoxPlayerCardState();
        });
    }
}
